import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class EdiaryReportService {	
  
  async find(responseDownload: any) {
    var questions = "";
    if (responseDownload.questions != null && responseDownload.questions.length > 0) {
      questions = responseDownload.questions.join(',');
    }
    return await Api().get(`${API_URL}/ediaryReport/find?startDate=${responseDownload.startDate}&endDate=${responseDownload.endDate}&questions=${responseDownload.questions}`, { headers:  authHeader() as any });      
  }
  
  async generate(responseDownload: any) {
    return (await Api().post(`${API_URL}/ediaryReport/generate`, responseDownload, { headers:  authHeader() as any })).data;      
  }

  async getMetadata() {
    return await Api().get(`${API_URL}/ediaryReport/metadata`, { headers:  authHeader() as any });      
  }  
}

export default new EdiaryReportService();